import { Card, Col, Row, Table } from "react-bootstrap";

export const RoomCategoryControl = ({ hotel }) => {

  console.log("RoomCategoryControl", hotel.summaryByCategory);

  return (
    <>
      <Row>
        <Col sm={12} className="col-12">
          <Card>
            <Card.Header>
              <h3 className="card-title mb-0">Habitaciones por categoria</h3>
            </Card.Header>
            <Card.Body>
              <div className="table-responsive">
                <Table className="table text-nowrap text-md-nowrap mg-b-0">
                  <tbody>
                    {
                      hotel.summaryByCategory.map((category, index) => (
                        <tr key={index}>
                          <td>{category.name}</td>
                          <td>{category.quantity}</td>
                        </tr>
                      ))
                    }
                    <tr style={{ fontWeight: "bold" }}>
                      <td>Total</td>
                      <td>{hotel.summaryByCategory.reduce((total, category) => total + category.quantity, 0)}</td>
                    </tr>
                  </tbody>
                </Table>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </>
  )
}
